var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin"},[_c('preloader-view',{staticClass:"o-v-rhythm--small"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }